import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import CreateTaldezainaTaskModal from './CreateTaldezainaTaskModal';
export default class TaldezainaTasksPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "canManage", false);
    _defineProperty(this, "tasks", []);
    _defineProperty(this, "matches", []);
    _defineProperty(this, "currentTab", 'pending');
    _defineProperty(this, "actionLoadingId", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.canManage = !!(app.forum.attribute('canManagePlayers') || app.session.user && (app.session.user.attribute('canManagePlayers') || app.session.user.isAdmin()));
    if (!this.canManage) {
      m.route.set('/');
      return;
    }
    this.loadData();
  }
  loadData() {
    this.loading = true;
    m.redraw();
    const pTasks = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/taldezaina/tasks?include=match.rival,creator,completer'
    });
    const latestSeason = app.forum.attribute('nagusiMatchRatingsLatestSeason') || '';
    const pMatches = app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/matches?include=rival' + (latestSeason ? "&season=".concat(encodeURIComponent(latestSeason)) : '')
    });
    Promise.all([pTasks, pMatches]).then(_ref => {
      let _ref2 = _slicedToArray(_ref, 2),
        tasksRes = _ref2[0],
        matchesRes = _ref2[1];
      this.tasks = app.store.pushPayload(tasksRes);
      this.matches = app.store.pushPayload(matchesRes);
      if (tasksRes && tasksRes.meta && typeof tasksRes.meta.pendingCount !== 'undefined') {
        if (!app.forum.data.attributes) {
          app.forum.data.attributes = {};
        }
        app.forum.data.attributes.pendingTaldezainaTasksCount = tasksRes.meta.pendingCount;
      }
      this.loading = false;
      m.redraw();
    }).catch(err => {
      console.error('Error loading Taldezaina tasks:', err);
      this.loading = false;
      m.redraw();
    });
  }
  openCreateTaskModal() {
    try {
      app.modal.show(CreateTaldezainaTaskModal, {
        matches: this.matches || [],
        existingTasks: this.tasks || [],
        onTaskCreated: () => this.loadData()
      });
    } catch (err) {
      console.error('Error opening CreateTaldezainaTaskModal:', err);
      app.alerts.show({
        type: 'error'
      }, 'Error abriendo modal: ' + ((err == null ? void 0 : err.message) || err));
    }
  }
  completeTask(task) {
    this.actionLoadingId = task.id();
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + "/taldezaina/tasks/".concat(task.id(), "/complete")
    }).then(res => {
      if (res && res.data) {
        app.store.pushPayload(res);
      }
      if (task && typeof task.pushData === 'function') {
        task.pushData({
          attributes: {
            status: 'completed',
            completedAt: new Date().toISOString()
          }
        });
      }
      const pendingCount = res && res.meta && typeof res.meta.pendingCount !== 'undefined' ? res.meta.pendingCount : Math.max(0, Number(app.forum.attribute('pendingTaldezainaTasksCount') || 0) - 1);
      if (!app.forum.data.attributes) {
        app.forum.data.attributes = {};
      }
      app.forum.data.attributes.pendingTaldezainaTasksCount = pendingCount;
      this.actionLoadingId = null;
      m.redraw();
      app.alerts.show({
        type: 'success'
      }, 'Tarea marcada como completada.');
      this.loadData();
    }).catch(err => {
      this.actionLoadingId = null;
      m.redraw();
      app.alerts.show({
        type: 'error'
      }, 'Error al completar la tarea.');
    });
  }
  getTaskIcon(taskKey) {
    switch (taskKey) {
      case 'match.pre.tv_channel':
        return '📺';
      case 'match.pre.referees':
        return '⚖️';
      case 'match.pre.press_conference':
        return '🎙️';
      case 'match.pre.callup':
        return '📋';
      case 'match.live.starting_eleven':
        return '👥';
      case 'match.post.score_and_goals':
        return '⚽';
      case 'match.post.final_participants':
        return '🏃';
      case 'match.post.attendance':
        return '🏟️';
      case 'match.post.press_conference':
        return '🎥';
      case 'match.post.highlights':
        return '🎬';
      case 'player.report_error':
        return '⚠️';
      default:
        return '✨';
    }
  }
  getStageBadge(taskKey) {
    if (taskKey === 'player.report_error') {
      return {
        label: 'Reporte Jugador',
        color: 'rgba(255, 159, 64, 0.25)'
      };
    }
    if (taskKey.includes('.pre.')) {
      return {
        label: 'Previa',
        color: 'rgba(54, 162, 235, 0.2)'
      };
    }
    if (taskKey.includes('.live.')) {
      return {
        label: 'Directo',
        color: 'rgba(255, 99, 132, 0.2)'
      };
    }
    if (taskKey.includes('.post.')) {
      return {
        label: 'Post-Partido',
        color: 'rgba(75, 192, 192, 0.2)'
      };
    }
    return {
      label: 'Personalizada',
      color: 'rgba(153, 102, 255, 0.2)'
    };
  }
  view() {
    if (!this.canManage) return null;
    const pendingTasks = this.tasks.filter(t => t.status() === 'pending');
    const completedTasks = this.tasks.filter(t => t.status() === 'completed');
    const displayTasks = this.currentTab === 'pending' ? pendingTasks : completedTasks;

    // Group tasks: by match (upcoming, previous, other matches) and general
    const generalTasks = displayTasks.filter(t => !t.matchId());
    const matchTasks = displayTasks.filter(t => !!t.matchId());

    // Unique match IDs in displayTasks
    const matchIds = Array.from(new Set(matchTasks.map(t => t.matchId())));
    const matchGroups = matchIds.map(mId => {
      const taskWithMatch = matchTasks.find(t => t.matchId() === mId);
      const match = (taskWithMatch && typeof taskWithMatch.match === 'function' ? taskWithMatch.match() : null) || this.matches.find(m => String(m.id()) === String(mId));
      const tasksForMatch = matchTasks.filter(t => t.matchId() === mId);
      return {
        matchId: mId,
        match,
        tasks: tasksForMatch
      };
    });
    return m("div", {
      className: "TaldezainaTasksPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 40px; padding-bottom: 60px; max-width: 960px;"
    }, m("div", {
      className: "Taldezaina-navigation",
      style: "display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; flex-wrap: wrap; gap: 15px;"
    }, m("div", {
      style: "display: flex; gap: 12px; align-items: center;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05);"
    }, m("i", {
      className: "fas fa-arrow-left"
    }), "Volver a Taldezaina")), m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-plus",
      style: "border-radius: 8px; font-weight: bold; padding: 10px 18px;",
      onclick: () => this.openCreateTaskModal()
    }, "Nueva Tarea")), m("div", {
      className: "Tasks-header",
      style: "margin-bottom: 30px;"
    }, m("div", {
      style: "display: flex; justify-content: space-between; align-items: flex-end; flex-wrap: wrap; gap: 15px;"
    }, m("div", null, m("h1", {
      style: "font-size: 2.4em; font-weight: 800; color: var(--heading-color); margin: 0; letter-spacing: -0.02em;"
    }, "Tareas de Taldezaina"), m("p", {
      style: "color: var(--muted-color); font-size: 1.1em; margin-top: 8px; max-width: 650px;"
    }, "Labores autom\xE1ticas y personalizadas para el seguimiento previo, directo y post-partido.")), m("div", {
      style: "display: flex; gap: 8px; background: rgba(255, 255, 255, 0.05); padding: 4px; border-radius: 10px; border: 1px solid rgba(255, 255, 255, 0.1);"
    }, m("button", {
      className: "Button ".concat(this.currentTab === 'pending' ? 'Button--primary' : 'Button--flat'),
      style: "border-radius: 8px; font-weight: bold; padding: 8px 16px;",
      onclick: () => {
        this.currentTab = 'pending';
      }
    }, "Pendientes (", pendingTasks.length, ")"), m("button", {
      className: "Button ".concat(this.currentTab === 'completed' ? 'Button--primary' : 'Button--flat'),
      style: "border-radius: 8px; font-weight: bold; padding: 8px 16px;",
      onclick: () => {
        this.currentTab = 'completed';
      }
    }, "Completadas (", completedTasks.length, ")")))), this.loading ? m("div", {
      style: "text-align: center; padding: 60px;"
    }, m(LoadingIndicator, null)) : displayTasks.length === 0 ? m("div", {
      style: "text-align: center; padding: 80px 20px; background: rgba(255, 255, 255, 0.02); border: 1px dashed rgba(255, 255, 255, 0.15); border-radius: 16px; margin-top: 20px;"
    }, m("div", {
      style: "font-size: 4rem; margin-bottom: 15px;"
    }, this.currentTab === 'pending' ? '🎉' : '📂'), m("h3", {
      style: "font-size: 1.4em; font-weight: 700; color: var(--heading-color); margin: 0 0 8px 0;"
    }, this.currentTab === 'pending' ? '¡Todo al día!' : 'No hay tareas completadas registradas'), m("p", {
      style: "color: var(--muted-color); font-size: 1.05em; max-width: 450px; margin: 0 auto 20px auto;"
    }, this.currentTab === 'pending' ? 'No hay ninguna tarea pendiente para los próximos partidos o el último disputado.' : 'A medida que se vayan cumpliendo o marcando tareas, aparecerán listadas aquí como histórico.'), this.currentTab === 'pending' && m(Button, {
      className: "Button Button--primary",
      icon: "fas fa-plus",
      style: "border-radius: 8px; font-weight: bold; padding: 10px 18px;",
      onclick: () => this.openCreateTaskModal()
    }, "Nueva Tarea")) : m("div", {
      style: "display: flex; flex-direction: column; gap: 30px;"
    }, matchGroups.map(group => {
      const mObj = group.match;
      const rivalName = mObj ? mObj.rival ? typeof mObj.rival === 'function' && mObj.rival() ? mObj.rival().name() : mObj.rival.name : mObj.opponent ? typeof mObj.opponent === 'function' ? mObj.opponent() : mObj.opponent : 'Rival' : 'Partido';
      const matchDate = mObj && mObj.matchDate ? typeof mObj.matchDate === 'function' ? mObj.matchDate() : mObj.matchDate : null;
      const formattedDate = matchDate ? new Date(matchDate).toLocaleDateString('es-ES', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        hour: '2-digit',
        minute: '2-digit'
      }) : '';
      return m("div", {
        key: "match-group-".concat(group.matchId),
        style: "background: rgba(255, 255, 255, 0.03); border: 1px solid rgba(255, 255, 255, 0.08); border-radius: 16px; overflow: hidden;"
      }, m("div", {
        style: "padding: 16px 20px; background: rgba(255, 255, 255, 0.04); border-bottom: 1px solid rgba(255, 255, 255, 0.08); display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px;"
      }, m("div", {
        style: "display: flex; align-items: center; gap: 10px;"
      }, m("span", {
        style: "font-size: 1.4rem;"
      }, "\uD83C\uDFDF\uFE0F"), m("span", {
        style: "font-size: 1.2em; font-weight: 800; color: var(--heading-color);"
      }, mObj && mObj.isLocal && (typeof mObj.isLocal === 'function' ? mObj.isLocal() : mObj.isLocal) ? "Athletic Club vs ".concat(rivalName) : "".concat(rivalName, " vs Athletic Club"))), formattedDate && m("span", {
        style: "font-size: 0.9em; color: var(--muted-color); font-weight: 600;"
      }, "\uD83D\uDCC5 ", formattedDate)), m("div", {
        style: "display: flex; flex-direction: column;"
      }, group.tasks.map(task => this.renderTaskItem(task))));
    }), generalTasks.length > 0 && m("div", {
      style: "background: rgba(255, 255, 255, 0.03); border: 1px solid rgba(255, 255, 255, 0.08); border-radius: 16px; overflow: hidden;"
    }, m("div", {
      style: "padding: 16px 20px; background: rgba(255, 255, 255, 0.04); border-bottom: 1px solid rgba(255, 255, 255, 0.08); display: flex; align-items: center; gap: 10px;"
    }, m("span", {
      style: "font-size: 1.4rem;"
    }, "\uD83D\uDCCC"), m("span", {
      style: "font-size: 1.2em; font-weight: 800; color: var(--heading-color);"
    }, "Tareas Generales y Reportes")), m("div", {
      style: "display: flex; flex-direction: column;"
    }, generalTasks.map(task => this.renderTaskItem(task)))))));
  }
  renderTaskItem(task) {
    const isCompleted = task.status() === 'completed';
    const badge = this.getStageBadge(task.taskKey());
    const icon = this.getTaskIcon(task.taskKey());
    const isActionLoading = this.actionLoadingId === task.id();
    return m("div", {
      key: "task-".concat(task.id()),
      style: "padding: 20px; border-bottom: 1px solid rgba(255, 255, 255, 0.05); display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 16px; transition: background 0.2s ease;"
    }, m("div", {
      style: "display: flex; gap: 16px; align-items: flex-start; flex: 1; min-width: 260px;"
    }, m("div", {
      style: "font-size: 2.2rem; line-height: 1; padding-top: 2px;"
    }, icon), m("div", {
      style: "display: flex; flex-direction: column; gap: 6px;"
    }, m("div", {
      style: "display: flex; align-items: center; gap: 10px; flex-wrap: wrap;"
    }, m("span", {
      style: "font-size: 1.15em; font-weight: 800; color: var(--heading-color);"
    }, task.title()), m("span", {
      style: "font-size: 0.75em; font-weight: bold; padding: 2px 8px; border-radius: 6px; background: ".concat(badge.color, "; color: var(--heading-color); text-transform: uppercase; letter-spacing: 0.05em;")
    }, badge.label), task.isManual() && m("span", {
      style: "font-size: 0.75em; font-weight: bold; padding: 2px 8px; border-radius: 6px; background: rgba(255, 255, 255, 0.1); color: var(--muted-color);"
    }, "Manual")), task.description() && m("p", {
      style: "margin: 0; color: var(--muted-color); font-size: 0.95em; line-height: 1.4;"
    }, task.description()), m("div", {
      style: "font-size: 0.85em; color: var(--muted-color); display: flex; gap: 12px; flex-wrap: wrap; margin-top: 2px;"
    }, task.creator() && m("span", null, "Por @", task.creator().username()), isCompleted && task.completer() && m("span", {
      style: "color: #4caf50; font-weight: 600;"
    }, "\u2713 Completada por @", task.completer().username()), isCompleted && task.completedAt() && m("span", null, "el ", new Date(task.completedAt()).toLocaleString())))), m("div", {
      style: "display: flex; gap: 10px; align-items: center; flex-wrap: wrap;"
    }, task.actionUrl() && m(Link, {
      href: task.actionUrl(),
      className: "Button Button--secondary",
      style: "border-radius: 8px; font-weight: bold; padding: 8px 14px; display: inline-flex; align-items: center; gap: 6px; border: 1px solid rgba(255, 255, 255, 0.15);"
    }, m("i", {
      className: "fas fa-external-link-alt"
    }), "Ir a resolver"), !isCompleted && m(Button, {
      className: "Button Button--primary",
      loading: isActionLoading,
      style: "border-radius: 8px; font-weight: bold; padding: 8px 14px; display: inline-flex; align-items: center; gap: 6px;",
      onclick: () => this.completeTask(task)
    }, m("i", {
      className: "fas fa-check"
    }), "Marcar completada")));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/taldezaina/TaldezainaTasksPage', TaldezainaTasksPage);